import { Session } from '@ais-ui/auth';

export const getBookmarks = async (session: Session): Promise<string> => {
  const response = await session.request('getBookmarkList', {});

  return response;
};
